/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.8.2.0 (NJsonSchema v10.2.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class SiteEquipmentsClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * Gets site equipments (Auth roles: Administrator,Pulinet)
   * @param query (optional)
   * @return Gets site equipments list
   */
  listAll(
    query: string | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<SiteEquipmentsListItemDTOQueryResult> {
    let url_ = this.baseUrl + '/siteequipments/list-all?';
    if (query === null) throw new Error("The parameter 'query' cannot be null.");
    else if (query !== undefined) url_ += 'query=' + encodeURIComponent('' + query) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processListAll(_response);
      });
  }

  protected processListAll(response: AxiosResponse): Promise<SiteEquipmentsListItemDTOQueryResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = SiteEquipmentsListItemDTOQueryResult.fromJS(resultData200);
      return result200;
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException(
        'A generic error occurred while getting admin site equipments list',
        status,
        _responseText,
        _headers
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<SiteEquipmentsListItemDTOQueryResult>(<any>null);
  }

  /**
   * Get sites list for customer (Auth roles: Customer; policy: Site_Equipments)
   * @return Return site equipments
   */
  myList(cancelToken?: CancelToken | undefined): Promise<SiteEquipmentsCustomerListItemDTO[]> {
    let url_ = this.baseUrl + '/siteequipments/my-list';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processMyList(_response);
      });
  }

  protected processMyList(response: AxiosResponse): Promise<SiteEquipmentsCustomerListItemDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(SiteEquipmentsCustomerListItemDTO.fromJS(item));
      }
      return result200;
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<SiteEquipmentsCustomerListItemDTO[]>(<any>null);
  }

  /**
   * Get site equipment by id (Auth policy: Site_Equipments)
   * @return Return site equipment by its id
   */
  detailCustomer(
    siteequipmentid: number,
    cancelToken?: CancelToken | undefined
  ): Promise<SiteEquipmentCustomerDetailDTO> {
    let url_ = this.baseUrl + '/siteequipments/detail-customer/{siteequipmentid}';
    if (siteequipmentid === undefined || siteequipmentid === null)
      throw new Error("The parameter 'siteequipmentid' must be defined.");
    url_ = url_.replace('{siteequipmentid}', encodeURIComponent('' + siteequipmentid));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDetailCustomer(_response);
      });
  }

  protected processDetailCustomer(response: AxiosResponse): Promise<SiteEquipmentCustomerDetailDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = SiteEquipmentCustomerDetailDTO.fromJS(resultData200);
      return result200;
    } else if (status === 400) {
      const _responseText = response.data;
      return throwException('Invalid siteequipmentid', status, _responseText, _headers);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException('No site equipment found', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<SiteEquipmentCustomerDetailDTO>(<any>null);
  }

  /**
   * Get site equipment by id
   * @param isPreview (optional)
   * @return Return site equipment qrcode image by qrcodeid
   */
  qrcode(
    qrcodeid: string,
    isPreview: boolean | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + '/siteequipments/qrcode/{qrcodeid}?';
    if (qrcodeid === undefined || qrcodeid === null) throw new Error("The parameter 'qrcodeid' must be defined.");
    url_ = url_.replace('{qrcodeid}', encodeURIComponent('' + qrcodeid));
    if (isPreview === null) throw new Error("The parameter 'isPreview' cannot be null.");
    else if (isPreview !== undefined) url_ += 'isPreview=' + encodeURIComponent('' + isPreview) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <AxiosRequestConfig>{
      responseType: 'blob',
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'image/png',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processQrcode(_response);
      });
  }

  protected processQrcode(response: AxiosResponse): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers['content-disposition'] : undefined;
      const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
      const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
    } else if (status === 400) {
      const _responseText = response.data;
      return throwException('Invalid qrcodeid', status, _responseText, _headers);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException('No site equipment found', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<FileResponse>(<any>null);
  }

  /**
   * Get qrcode-url by qrcodeid
   * @return Return qrcode-url by qrcodeid
   */
  qrcodeUrl(qrcodeid: string, cancelToken?: CancelToken | undefined): Promise<string> {
    let url_ = this.baseUrl + '/siteequipments/qrcode-url/{qrcodeid}';
    if (qrcodeid === undefined || qrcodeid === null) throw new Error("The parameter 'qrcodeid' must be defined.");
    url_ = url_.replace('{qrcodeid}', encodeURIComponent('' + qrcodeid));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processQrcodeUrl(_response);
      });
  }

  protected processQrcodeUrl(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;
      return result200;
    } else if (status === 400) {
      const _responseText = response.data;
      return throwException('Invalid qrcodeid', status, _responseText, _headers);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException('No site equipment found', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<string>(<any>null);
  }

  /**
   * Get site equipment by id
   * @return Return site equipment by its qrcodeid
   */
  detailQrcode(qrcodeid: string, cancelToken?: CancelToken | undefined): Promise<SiteEquipmentCustomerDetailDTO> {
    let url_ = this.baseUrl + '/siteequipments/detail-qrcode/{qrcodeid}';
    if (qrcodeid === undefined || qrcodeid === null) throw new Error("The parameter 'qrcodeid' must be defined.");
    url_ = url_.replace('{qrcodeid}', encodeURIComponent('' + qrcodeid));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDetailQrcode(_response);
      });
  }

  protected processDetailQrcode(response: AxiosResponse): Promise<SiteEquipmentCustomerDetailDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = SiteEquipmentCustomerDetailDTO.fromJS(resultData200);
      return result200;
    } else if (status === 400) {
      const _responseText = response.data;
      return throwException('Invalid qrcodeid', status, _responseText, _headers);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException('No site equipment found', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<SiteEquipmentCustomerDetailDTO>(<any>null);
  }

  /**
   * Get site equipment by id (Auth roles: Administrator,Pulinet)
   * @return Return site equipment by its id
   */
  siteequipmentsGet(siteequipmentid: number, cancelToken?: CancelToken | undefined): Promise<SiteEquipmentDTO> {
    let url_ = this.baseUrl + '/siteequipments/{siteequipmentid}';
    if (siteequipmentid === undefined || siteequipmentid === null)
      throw new Error("The parameter 'siteequipmentid' must be defined.");
    url_ = url_.replace('{siteequipmentid}', encodeURIComponent('' + siteequipmentid));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSiteequipmentsGet(_response);
      });
  }

  protected processSiteequipmentsGet(response: AxiosResponse): Promise<SiteEquipmentDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = SiteEquipmentDTO.fromJS(resultData200);
      return result200;
    } else if (status === 400) {
      const _responseText = response.data;
      return throwException('Invalid siteequipmentid', status, _responseText, _headers);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException('No site equipment found', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<SiteEquipmentDTO>(<any>null);
  }

  /**
   * Get a unique qrCodeId
   * @return Return unique qrCodeId
   */
  uniqueQrcodeid(cancelToken?: CancelToken | undefined): Promise<string> {
    let url_ = this.baseUrl + '/siteequipments/unique-qrcodeid';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUniqueQrcodeid(_response);
      });
  }

  protected processUniqueQrcodeid(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;
      return result200;
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<string>(<any>null);
  }

  /**
   * Adds new site equipment (Auth roles: Administrator,Pulinet)
   * @param body (optional)
   * @return Added new site equipment
   */
  siteequipmentsPost(body: SiteEquipmentDTO | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + '/siteequipments';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json-patch+json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSiteequipmentsPost(_response);
      });
  }

  protected processSiteequipmentsPost(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status === 400) {
      const _responseText = response.data;
      return throwException(
        'Invalid field values: some values are missing or not valid',
        status,
        _responseText,
        _headers
      );
    } else if (status === 409) {
      const _responseText = response.data;
      return throwException('The qrcode id already exists', status, _responseText, _headers);
    } else if (status === 421) {
      const _responseText = response.data;
      return throwException('The qrcode id length is not valid', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Update site equipment (Auth roles: Administrator,Pulinet)
   * @param body (optional)
   * @return Updated site equipment
   */
  siteequipmentsPut(body: SiteEquipmentDTO | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + '/siteequipments';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json-patch+json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSiteequipmentsPut(_response);
      });
  }

  protected processSiteequipmentsPut(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status === 400) {
      const _responseText = response.data;
      return throwException(
        'Invalid field values: some values are missing or not valid',
        status,
        _responseText,
        _headers
      );
    } else if (status === 409) {
      const _responseText = response.data;
      return throwException('The qrcode id already exists', status, _responseText, _headers);
    } else if (status === 420) {
      const _responseText = response.data;
      return throwException('The qrcode id cannot be removed', status, _responseText, _headers);
    } else if (status === 421) {
      const _responseText = response.data;
      return throwException('The qrcode id length is not valid', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Delete site equipment by id (Auth roles: Administrator,Pulinet)
   * @return Delete site equipment
   */
  siteequipmentsDelete(id: number, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + '/siteequipments/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <AxiosRequestConfig>{
      method: 'DELETE',
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSiteequipmentsDelete(_response);
      });
  }

  protected processSiteequipmentsDelete(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException('Site equipment not found', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Get All SiteEquipment document list (Auth roles: Administrator,Customer,Pulinet; policy: Site_Equipments)
   * @param query (optional) Serialization of QueryInfo data Type
   * @return Return all employee document list
   */
  documents(
    siteequipmentid: number,
    query: string | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<DocumentListItemDTOQueryResult> {
    let url_ = this.baseUrl + '/siteequipments/{siteequipmentid}/list/documents?';
    if (siteequipmentid === undefined || siteequipmentid === null)
      throw new Error("The parameter 'siteequipmentid' must be defined.");
    url_ = url_.replace('{siteequipmentid}', encodeURIComponent('' + siteequipmentid));
    if (query === null) throw new Error("The parameter 'query' cannot be null.");
    else if (query !== undefined) url_ += 'query=' + encodeURIComponent('' + query) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDocuments(_response);
      });
  }

  protected processDocuments(response: AxiosResponse): Promise<DocumentListItemDTOQueryResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = DocumentListItemDTOQueryResult.fromJS(resultData200);
      return result200;
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Is not customer employee', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<DocumentListItemDTOQueryResult>(<any>null);
  }

  /**
   * Saves new SiteEquipment Document (Auth roles: Administrator,Pulinet)
   * @param body (optional)
   * @return Adds new site equipment document
   */
  document(
    body: SiteEquipmentDocumentDTO | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<DocumentReferenceDTO> {
    let url_ = this.baseUrl + '/siteequipments/attach/document';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json-patch+json',
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDocument(_response);
      });
  }

  protected processDocument(response: AxiosResponse): Promise<DocumentReferenceDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = DocumentReferenceDTO.fromJS(resultData200);
      return result200;
    } else if (status === 400) {
      const _responseText = response.data;
      return throwException('Incorrect Data', status, _responseText, _headers);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException('Document not found', status, _responseText, _headers);
    } else if (status === 409) {
      const _responseText = response.data;
      return throwException('Extension not allowed', status, _responseText, _headers);
    } else if (status === 422) {
      const _responseText = response.data;
      return throwException('Association already exist', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<DocumentReferenceDTO>(<any>null);
  }

  /**
   * Get a PDF document containing a grid with the site equipments' qrcodes (Auth roles: Administrator,Pulinet)
   * @param query (optional)
   * @return Gets site equipments qrcodes list in PDF format
   */
  qrcodePdf(query: string | undefined, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
    let url_ = this.baseUrl + '/siteequipments/qrcode-pdf?';
    if (query === null) throw new Error("The parameter 'query' cannot be null.");
    else if (query !== undefined) url_ += 'query=' + encodeURIComponent('' + query) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <AxiosRequestConfig>{
      responseType: 'blob',
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/pdf',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processQrcodePdf(_response);
      });
  }

  protected processQrcodePdf(response: AxiosResponse): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers['content-disposition'] : undefined;
      const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
      const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException(
        'A generic error occurred while getting admin site equipments list',
        status,
        _responseText,
        _headers
      );
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<FileResponse>(<any>null);
  }
}

export class DocumentListItemDTO implements IDocumentListItemDTO {
  documentId?: number;
  title?: string | undefined;
  description?: string | undefined;
  creationDate?: Date;
  lastDownload?: Date | undefined;
  downloadCount?: number;
  filename?: string | undefined;
  associationCount?: number;
  outdated?: boolean;
  category?: string | undefined;

  constructor(data?: IDocumentListItemDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.documentId = _data['documentId'];
      this.title = _data['title'];
      this.description = _data['description'];
      this.creationDate = _data['creationDate'] ? new Date(_data['creationDate'].toString()) : <any>undefined;
      this.lastDownload = _data['lastDownload'] ? new Date(_data['lastDownload'].toString()) : <any>undefined;
      this.downloadCount = _data['downloadCount'];
      this.filename = _data['filename'];
      this.associationCount = _data['associationCount'];
      this.outdated = _data['outdated'];
      this.category = _data['category'];
    }
  }

  static fromJS(data: any): DocumentListItemDTO {
    data = typeof data === 'object' ? data : {};
    let result = new DocumentListItemDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['documentId'] = this.documentId;
    data['title'] = this.title;
    data['description'] = this.description;
    data['creationDate'] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
    data['lastDownload'] = this.lastDownload ? this.lastDownload.toISOString() : <any>undefined;
    data['downloadCount'] = this.downloadCount;
    data['filename'] = this.filename;
    data['associationCount'] = this.associationCount;
    data['outdated'] = this.outdated;
    data['category'] = this.category;
    return data;
  }
}

export interface IDocumentListItemDTO {
  documentId?: number;
  title?: string | undefined;
  description?: string | undefined;
  creationDate?: Date;
  lastDownload?: Date | undefined;
  downloadCount?: number;
  filename?: string | undefined;
  associationCount?: number;
  outdated?: boolean;
  category?: string | undefined;
}

export class DocumentListItemDTOQueryResult implements IDocumentListItemDTOQueryResult {
  data?: DocumentListItemDTO[] | undefined;
  total?: number;

  constructor(data?: IDocumentListItemDTOQueryResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        this.data = [] as any;
        for (let item of _data['data']) this.data!.push(DocumentListItemDTO.fromJS(item));
      }
      this.total = _data['total'];
    }
  }

  static fromJS(data: any): DocumentListItemDTOQueryResult {
    data = typeof data === 'object' ? data : {};
    let result = new DocumentListItemDTOQueryResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.data)) {
      data['data'] = [];
      for (let item of this.data) data['data'].push(item.toJSON());
    }
    data['total'] = this.total;
    return data;
  }
}

export interface IDocumentListItemDTOQueryResult {
  data?: DocumentListItemDTO[] | undefined;
  total?: number;
}

export class DocumentReferenceDTO implements IDocumentReferenceDTO {
  documentId?: number;
  url?: string | undefined;

  constructor(data?: IDocumentReferenceDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.documentId = _data['documentId'];
      this.url = _data['url'];
    }
  }

  static fromJS(data: any): DocumentReferenceDTO {
    data = typeof data === 'object' ? data : {};
    let result = new DocumentReferenceDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['documentId'] = this.documentId;
    data['url'] = this.url;
    return data;
  }
}

export interface IDocumentReferenceDTO {
  documentId?: number;
  url?: string | undefined;
}

export class SiteEquipmentCustomerDetailDTO implements ISiteEquipmentCustomerDetailDTO {
  id?: number;
  serialNumber?: string | undefined;
  description?: string | undefined;
  model?: string | undefined;
  brandName?: string | undefined;
  note?: string | undefined;
  customerCode?: string | undefined;
  siteId?: string | undefined;
  qrCodeId?: string | undefined;
  siteName?: string | undefined;
  qrCodeUrl?: string | undefined;

  constructor(data?: ISiteEquipmentCustomerDetailDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.serialNumber = _data['serialNumber'];
      this.description = _data['description'];
      this.model = _data['model'];
      this.brandName = _data['brandName'];
      this.note = _data['note'];
      this.customerCode = _data['customerCode'];
      this.siteId = _data['siteId'];
      this.qrCodeId = _data['qrCodeId'];
      this.siteName = _data['siteName'];
      this.qrCodeUrl = _data['qrCodeUrl'];
    }
  }

  static fromJS(data: any): SiteEquipmentCustomerDetailDTO {
    data = typeof data === 'object' ? data : {};
    let result = new SiteEquipmentCustomerDetailDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['serialNumber'] = this.serialNumber;
    data['description'] = this.description;
    data['model'] = this.model;
    data['brandName'] = this.brandName;
    data['note'] = this.note;
    data['customerCode'] = this.customerCode;
    data['siteId'] = this.siteId;
    data['qrCodeId'] = this.qrCodeId;
    data['siteName'] = this.siteName;
    data['qrCodeUrl'] = this.qrCodeUrl;
    return data;
  }
}

export interface ISiteEquipmentCustomerDetailDTO {
  id?: number;
  serialNumber?: string | undefined;
  description?: string | undefined;
  model?: string | undefined;
  brandName?: string | undefined;
  note?: string | undefined;
  customerCode?: string | undefined;
  siteId?: string | undefined;
  qrCodeId?: string | undefined;
  siteName?: string | undefined;
  qrCodeUrl?: string | undefined;
}

export class SiteEquipmentDTO implements ISiteEquipmentDTO {
  id?: number;
  serialNumber?: string | undefined;
  description?: string | undefined;
  model?: string | undefined;
  brandName?: string | undefined;
  note?: string | undefined;
  customerCode?: string | undefined;
  siteId?: string | undefined;
  qrCodeId?: string | undefined;
  qrCodeUrl?: string | undefined;

  constructor(data?: ISiteEquipmentDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.serialNumber = _data['serialNumber'];
      this.description = _data['description'];
      this.model = _data['model'];
      this.brandName = _data['brandName'];
      this.note = _data['note'];
      this.customerCode = _data['customerCode'];
      this.siteId = _data['siteId'];
      this.qrCodeId = _data['qrCodeId'];
      this.qrCodeUrl = _data['qrCodeUrl'];
    }
  }

  static fromJS(data: any): SiteEquipmentDTO {
    data = typeof data === 'object' ? data : {};
    let result = new SiteEquipmentDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['serialNumber'] = this.serialNumber;
    data['description'] = this.description;
    data['model'] = this.model;
    data['brandName'] = this.brandName;
    data['note'] = this.note;
    data['customerCode'] = this.customerCode;
    data['siteId'] = this.siteId;
    data['qrCodeId'] = this.qrCodeId;
    data['qrCodeUrl'] = this.qrCodeUrl;
    return data;
  }
}

export interface ISiteEquipmentDTO {
  id?: number;
  serialNumber?: string | undefined;
  description?: string | undefined;
  model?: string | undefined;
  brandName?: string | undefined;
  note?: string | undefined;
  customerCode?: string | undefined;
  siteId?: string | undefined;
  qrCodeId?: string | undefined;
  qrCodeUrl?: string | undefined;
}

export class SiteEquipmentDocumentDTO implements ISiteEquipmentDocumentDTO {
  siteEquipmentId?: number;
  documentId?: number;
  title?: string | undefined;
  description?: string | undefined;
  filename?: string | undefined;
  dataUrl?: string | undefined;
  outdated?: boolean;
  category?: string | undefined;

  constructor(data?: ISiteEquipmentDocumentDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.siteEquipmentId = _data['siteEquipmentId'];
      this.documentId = _data['documentId'];
      this.title = _data['title'];
      this.description = _data['description'];
      this.filename = _data['filename'];
      this.dataUrl = _data['dataUrl'];
      this.outdated = _data['outdated'];
      this.category = _data['category'];
    }
  }

  static fromJS(data: any): SiteEquipmentDocumentDTO {
    data = typeof data === 'object' ? data : {};
    let result = new SiteEquipmentDocumentDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['siteEquipmentId'] = this.siteEquipmentId;
    data['documentId'] = this.documentId;
    data['title'] = this.title;
    data['description'] = this.description;
    data['filename'] = this.filename;
    data['dataUrl'] = this.dataUrl;
    data['outdated'] = this.outdated;
    data['category'] = this.category;
    return data;
  }
}

export interface ISiteEquipmentDocumentDTO {
  siteEquipmentId?: number;
  documentId?: number;
  title?: string | undefined;
  description?: string | undefined;
  filename?: string | undefined;
  dataUrl?: string | undefined;
  outdated?: boolean;
  category?: string | undefined;
}

export class SiteEquipmentsCustomerListItemDTO implements ISiteEquipmentsCustomerListItemDTO {
  id?: number;
  serialNumber?: string | undefined;
  model?: string | undefined;
  brandName?: string | undefined;
  siteName?: string | undefined;
  siteCode?: string | undefined;
  description?: string | undefined;
  qrCodeUrl?: string | undefined;
  qrCodeId?: string | undefined;

  constructor(data?: ISiteEquipmentsCustomerListItemDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.serialNumber = _data['serialNumber'];
      this.model = _data['model'];
      this.brandName = _data['brandName'];
      this.siteName = _data['siteName'];
      this.siteCode = _data['siteCode'];
      this.description = _data['description'];
      this.qrCodeUrl = _data['qrCodeUrl'];
      this.qrCodeId = _data['qrCodeId'];
    }
  }

  static fromJS(data: any): SiteEquipmentsCustomerListItemDTO {
    data = typeof data === 'object' ? data : {};
    let result = new SiteEquipmentsCustomerListItemDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['serialNumber'] = this.serialNumber;
    data['model'] = this.model;
    data['brandName'] = this.brandName;
    data['siteName'] = this.siteName;
    data['siteCode'] = this.siteCode;
    data['description'] = this.description;
    data['qrCodeUrl'] = this.qrCodeUrl;
    data['qrCodeId'] = this.qrCodeId;
    return data;
  }
}

export interface ISiteEquipmentsCustomerListItemDTO {
  id?: number;
  serialNumber?: string | undefined;
  model?: string | undefined;
  brandName?: string | undefined;
  siteName?: string | undefined;
  siteCode?: string | undefined;
  description?: string | undefined;
  qrCodeUrl?: string | undefined;
  qrCodeId?: string | undefined;
}

export class SiteEquipmentsListItemDTO implements ISiteEquipmentsListItemDTO {
  id?: number;
  serialNumber?: string | undefined;
  model?: string | undefined;
  brandName?: string | undefined;
  siteName?: string | undefined;
  siteCode?: string | undefined;
  description?: string | undefined;
  qrCodeUrl?: string | undefined;
  qrCodeId?: string | undefined;
  customerName?: string | undefined;
  customerCode?: string | undefined;

  constructor(data?: ISiteEquipmentsListItemDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.serialNumber = _data['serialNumber'];
      this.model = _data['model'];
      this.brandName = _data['brandName'];
      this.siteName = _data['siteName'];
      this.siteCode = _data['siteCode'];
      this.description = _data['description'];
      this.qrCodeUrl = _data['qrCodeUrl'];
      this.qrCodeId = _data['qrCodeId'];
      this.customerName = _data['customerName'];
      this.customerCode = _data['customerCode'];
    }
  }

  static fromJS(data: any): SiteEquipmentsListItemDTO {
    data = typeof data === 'object' ? data : {};
    let result = new SiteEquipmentsListItemDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['serialNumber'] = this.serialNumber;
    data['model'] = this.model;
    data['brandName'] = this.brandName;
    data['siteName'] = this.siteName;
    data['siteCode'] = this.siteCode;
    data['description'] = this.description;
    data['qrCodeUrl'] = this.qrCodeUrl;
    data['qrCodeId'] = this.qrCodeId;
    data['customerName'] = this.customerName;
    data['customerCode'] = this.customerCode;
    return data;
  }
}

export interface ISiteEquipmentsListItemDTO {
  id?: number;
  serialNumber?: string | undefined;
  model?: string | undefined;
  brandName?: string | undefined;
  siteName?: string | undefined;
  siteCode?: string | undefined;
  description?: string | undefined;
  qrCodeUrl?: string | undefined;
  qrCodeId?: string | undefined;
  customerName?: string | undefined;
  customerCode?: string | undefined;
}

export class SiteEquipmentsListItemDTOQueryResult implements ISiteEquipmentsListItemDTOQueryResult {
  data?: SiteEquipmentsListItemDTO[] | undefined;
  total?: number;

  constructor(data?: ISiteEquipmentsListItemDTOQueryResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        this.data = [] as any;
        for (let item of _data['data']) this.data!.push(SiteEquipmentsListItemDTO.fromJS(item));
      }
      this.total = _data['total'];
    }
  }

  static fromJS(data: any): SiteEquipmentsListItemDTOQueryResult {
    data = typeof data === 'object' ? data : {};
    let result = new SiteEquipmentsListItemDTOQueryResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.data)) {
      data['data'] = [];
      for (let item of this.data) data['data'].push(item.toJSON());
    }
    data['total'] = this.total;
    return data;
  }
}

export interface ISiteEquipmentsListItemDTOQueryResult {
  data?: SiteEquipmentsListItemDTO[] | undefined;
  total?: number;
}

export interface FileResponse {
  data: Blob;
  status: number;
  fileName?: string;
  headers?: { [name: string]: any };
}

export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
  return obj && obj.isAxiosError === true;
}
